<div class="flex-row full-container">
  <ng-container *ngIf="isEditing; else display">
    <company-picker
      [company]="participatingCompany.localCompany"
      [canEdit]="true"
      (companyIsSelected)="onCompanyIsSelected($event)"
    ></company-picker>
  </ng-container>
  <ng-template #display>
    <label>{{ participatingCompany.company?.regularName }}</label>
  </ng-template>
  <div class="flex-row action-buttons">
    <ng-container *ngIf="isEditing; else displayIcons">
      <mat-icon
        [matTooltip]="'Stop aanpassen'"
        class="action"
        (click)="stopEditing()"
        >details</mat-icon
      >
    </ng-container>
    <ng-template #displayIcons>
      <mat-icon
        [matTooltip]="'Aanpassen'"
        class="action"
        (click)="startEditing()"
        >edit</mat-icon
      >
    </ng-template>
    <mat-icon [matTooltip]="'Verwijderen'" class="action" (click)="remove()"
      >close</mat-icon
    >
  </div>
</div>
